// Those objects class are used as responsed from the BIMSearch engine
export class DataForMenus {
    constructor() {
        this.quickCounterData = null; // [] of QuickDataField, elements order: count, length, area, volume

        // menu lists
        this.templates = null; // [] of strings
        this.templatesCount = null; //[] of numbers number of elements for each template
        this.templatesFolder = null; // Dictionary<string, [] of string>
        this.categories = null; // [] of strings
        this.filterByOptions = null; // [] of strings
        this.filterValues = null; // [] of string or numbers
        this.properties = null; // [] of strings
        this.groupingOptions = null; // [] of strings
        this.commonCategories = null; // [] of strings
        this.uncommonCategories = null; // [] of strings
        this.commonProperties = null; // [] of strings
        this.uncommonProperties = null; // [] of strings
        this.commonGroupingOptions = null; // [] of strings
        this.uncommonGroupingOptions = null; // [] of strings
        this.conditionalFormatting = null; // object of type ColorConditions 
        this.customColumns = null; // object of type CustomColumns 

        // MenusSelection 
        this.selection = null;
    }

    empty() {
        this.templates = []; // [] of strings
        this.templatesCount = []; //[] of numbers number of elements for each template
        this.templatesFolder = {}; // Dictionary<string, [] of string>
        this.categories = []; // [] of strings
        this.filterByOptions = []; // [] of strings
        this.filterValues = []; // [] of string or numbers
        this.properties = []; // [] of strings
        this.groupingOptions = []; // [] of strings
        this.commonCategories = []; // [] of strings
        this.uncommonCategories = []; // [] of strings
        this.commonProperties = []; // [] of strings
        this.uncommonProperties = []; // [] of strings
        this.commonGroupingOptions = []; // [] of strings
        this.uncommonGroupingOptions = []; // [] of strings
        this.conditionalFormatting = null; // object of type ColorConditions 
        this.customColumns = null; // object of type CustomColumns 
    }
}

export class QuickDataField {
    constructor(name, value = 0, unit = null) {
        this.name = name;
        this.value = value;
        this.unit = unit;
    }
}

export class MenusSelection {
    constructor(
        selectedCategories,
        selectedSecondFilter,
        selectedFilterValues,
        selectedProperties,
        selectedGroups,
        searchValue
    ) {
        this.categories = selectedCategories; // string
        this.secondFilter = selectedSecondFilter; // string
        this.filterValues = selectedFilterValues; // [] of strings
        this.properties = selectedProperties; // [] of strings
        this.groups = selectedGroups; // [] of strings
        this.searchValue = searchValue
    }
}

// n - number of colums in the table, not including check box
// m - number of lines in the table, not including header and total line
export class DataForTable {
    constructor() {
        this.header = []; // size n [] of strings
        this.units = []; // size n [] of strings representing units for each column, null if no units or mixed units
        this.lines = []; // size m [] of size n [] of values (string or numbers)
        this.totals = []; // size n [] of values (string or numbers)
        this.lineElements = []; // size m [] of [] of ids
        this.types = []; // // size n [] of valueTypes representing the type of each column
    }
}

export class QuickInfo {
    constructor(creationTime, quickData, parameters, description) {
        this.creationTime = creationTime; // Timestamp // negative value --> don't display
        this.quickData = quickData; // [] of QuickDataField
        this.parameters = parameters; // [] of string
        this.descreption = description; // string
    }
}


// Exported enum
export const operatorValues = {
    equal: 0,
    notEqual: 1,
    greater: 2,
    less: 3,
    greaterOrEqual: 4,
    lessOrEqual: 5,
};

// Exported enum
export const valueTypes = {
    unknown: -1,
    number: 0,
    text: 1,
    date: 2,
};
